// extracted by mini-css-extract-plugin
export var Wrap = "LoaderArticles-module--Wrap--+Y-7v";
export var Left = "LoaderArticles-module--Left--kv2qh";
export var Avatar = "LoaderArticles-module--Avatar--MtbVk";
export var PreloaderActionItem_placeholderSkeleton = "LoaderArticles-module--PreloaderActionItem_placeholderSkeleton--p4Q2t";
export var Date = "LoaderArticles-module--Date--aHhig";
export var Right = "LoaderArticles-module--Right--O+Dxw";
export var Title = "LoaderArticles-module--Title--MYw8O";
export var TitleLine = "LoaderArticles-module--TitleLine--h-Tx5";
export var DescLine = "LoaderArticles-module--DescLine--mhpBk";
export var arrowLeft = "LoaderArticles-module--arrowLeft--kr8b3";
export var arrowRight = "LoaderArticles-module--arrowRight--tUbyS";